import { Box, Modal } from '@mui/material';
import { Button } from 'atoms/Button';
import React from 'react';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'var(--c-background2)',
  borderRadius: '10px',
  p: 4,
  border: '1px solid var(--c-primary-color)',
  height: '20rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
};

export const ExsitingUserDialog: React.FC<{
  onNext: () => void;
  onLogin: () => void;
}> = ({ onNext, onLogin }) => {
  const { t: tAuditionForm } = useTranslationWithLang('auditionForm');
  return (
    <Modal open={true} slotProps={{ backdrop: { 'aria-hidden': true } }}>
      <Box sx={style} role="alertdialog" aria-modal="true">
        <div className="sr-only" aria-atomic="true" aria-live="assertive">
          {tAuditionForm('TU002_073')} {tAuditionForm('TU002_074')}
        </div>

        <div>
          <p>{tAuditionForm('TU002_073')}</p>
          <p>{tAuditionForm('TU002_074')}</p>
        </div>

        <div className="flex items-center justify-center mt-8">
          <button
            className="text-[--c-nav-text] flex items-center hover:underline cursor-pointer"
            onClick={onLogin}
            tabIndex={0}
          >
            <ArrowRightIcon className="ml-[-16px]" />
            <span>{tAuditionForm('TU002_071')}</span>
          </button>
        </div>
        <div className={'flex justify-center mt-auto'}>
          <Button label={tAuditionForm('TU002_077')} onClick={onNext} />
        </div>
      </Box>
    </Modal>
  );
};
